import { useQueries } from "@tanstack/react-query";
import { formatResultQueries } from "hook/common/returnData";
import { STALE_TIME } from "hook/constansts/query";
import CustomerService from "services/CustomerService";
import IssueInvoiceService from "services/IssueInvoiceService";
import productService from "services/ProductService";

export const useConfigInvoiceField = (
  payloadSearchProduct,
  isGetData = {
    listVats: true,
    listPaymentMethods: true,
    listCurrencies: true,
    listAllProduct: true,
    listAllAccountBank: true,
    listAllCustomer: true,
    configInvoice: true,
  },
  enabled,
  bu_code,
  onSuccess,
  onError
) => {
  let listResult = useQueries({
    queries: [
      {
        queryKey: ["listVats"],
        queryFn: IssueInvoiceService.listVats,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listVats && enabled,
        select: response => {
          const listVat = response.items.map(item => {
            return {
              value: item.tsuat,
              label: item.ltsuat,
              id: item.id,
            };
          });
          return listVat;
        },
      },
      {
        queryKey: ["listPaymentMethods"],
        queryFn: IssueInvoiceService.listPaymentMethods,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listPaymentMethods && enabled,
        select: response => {
          const listPaymentMethod = response.items.map(item => {
            return {
              value: item.htttoan,
              label: item.htttoan,
              id: item.id,
            };
          });
          return listPaymentMethod;
        },
      },
      {
        queryKey: ["listCurrencies"],
        queryFn: IssueInvoiceService.listCurrencies,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listCurrencies && enabled,
        select: response => {
          // Nếu có VND thì move lên đầu
          let defaultVND = {
            value: "VND",
            label: "VND",
          };
          let listCurrency = [];
          if (response) {
            let items = response.items.map(item => {
              return {
                value: item.dvtte,
                label: item.dvtte,
              };
            });
            if (
              !items.filter(item => item.label === "VND") ||
              items.length === 0
            ) {
              items.push(defaultVND);
            }
            items = items.sort((x, y) => {
              return x.label == "VND" ? -1 : y.label == "VND" ? 1 : 0;
            });
            listCurrency = items;
          } else {
            // K có thì mặc dịnh VND
            listCurrency = [defaultVND];
          }
          return listCurrency;
        },
      },
      {
        queryKey: ["listAllProduct"],
        queryFn: () => productService.listAllProduct(payloadSearchProduct),
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listAllProduct && enabled,
        select: response => {
          const list = response.items.map(item => {
            return {
              ...item,
              value: item.name,
              label: item.code + " - " + item.name,
            };
          });
          return list;
        },
      },
      {
        queryKey: ["listAllAccountBank"],
        queryFn: CustomerService.listAllAccountBank,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listAllAccountBank && enabled,
        select: response => {
          const list = response.items.map(item => {
            return {
              ...item,
              value: item.account_number,
              label: item.account_number + " - " + item.bank_name,
            };
          });
          return list;
        },
      },
      {
        queryKey: ["listAllCustomer"],
        queryFn: CustomerService.listAllCustomer,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.listAllCustomer && enabled,
        select: response => {
          const list = response.items.map(item => {
            return {
              ...item,
              value: item.ma,
              label: item.ma,
            };
          });
          return list;
        },
      },
      {
        queryKey: ["configInvoice", bu_code],
        queryFn: IssueInvoiceService.configInvoice,
        retry: 1,
        staleTime: STALE_TIME,
        enabled: isGetData.configInvoice && enabled,
        select: response => {
          if (response.items.length > 0) {
            return response.items[0].data;
          }
          return null;
        },
      },
    ],
  });

  return formatResultQueries(listResult);
};
